module.exports = __webpack_public_path__ + "img/loue.74ddb77b.png";